import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-hot-corner',
  templateUrl: './hot-corner.component.html',
  styleUrls: ['./hot-corner.component.scss']
})
export class HotCornerComponent {
  hotCornerClass!: string;
 positionContent = 'Right bottom hotcorner' as string;
  constructor(
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(param => {
      if(param.hotCornerClass === 'c-hot-corners--bottom-right'){
        this.positionContent =  'Content at Right bottom corner';
      } else if(param.hotCornerClass === 'c-hot-corners--top-right'){
        this.positionContent =  'Content at  Right top corner';
      }else if(param.hotCornerClass === 'c-hot-corners--top-left'){
        this.positionContent =  'Content at Left top corner';
      } else if(param.hotCornerClass === 'c-hot-corners--bottom-left'){
        this.positionContent =  'Content at Left bottom corner';
      }
    })
   }

  
  getHotCorner(hotCornerClass: string) {
    this.hotCornerClass = hotCornerClass;
  }
}